<template>
  <el-row>
    <el-select v-model="provinceValue" placeholder="省" @change="selectProvince" style="width: 120px" size="small">
      <el-option class="my-item" v-for="(item, index) of provinceArr" :key="index" :label="item.name"
        :value="item.id"></el-option>
    </el-select>
    <el-select v-model="cityValue" placeholder="市" @change="selectCity" style="width: 120px" size="small"
      v-if="showCity">
      <el-option class="my-item" v-for="(item, index) of cityArr" :key="index" :label="item.name"
        :value="item.id"></el-option>
    </el-select>
    <el-select placeholder="区" @change="selectCountry" v-model="RegionValue" style="width: 120px" size="small"
      v-if="showRegion">
      <el-option class="my-item" v-for="(item, index) of regionArr" :key="index" :label="item.name"
        :value="item.id"></el-option>
    </el-select>
  </el-row>
</template>
<script>

import { province } from '../utils/map.js'

export default {

  created() {
    this.provinceArr = province;
    this.provinceArr.push({
      id:'999999',
      name:'手动输入',
      children:[]
    });
  },
  data() {
    return {
      province: [],
      cityArr: [],
      regionArr: [],
      provinceValue: '',
      cityValue: '',
      RegionValue: '',
      showCity:true,
      showRegion:true
    }
  },
  mounted() { },
  methods: {
    selectProvince(id) {
      this.cityArr = [];
      this.regionArr = [];
      this.cityValue = '';
      this.RegionValue = '';
      for (let item of this.provinceArr) {
        if (id == item.id) {
          this.cityArr = item.children;
          this.provinceValue = item.name;
          if(this.cityArr&&this.cityArr.length<=0){
            this.showCity = false;
            this.showRegion = false;
          }else{
            this.showCity = true;
            this.showRegion = true;
          }
        }
      }
      this.$emit('selMap', this.provinceValue, this.cityValue, this.RegionValue)
    },
    selectCity(id) {
      this.regionArr = [];
      this.RegionValue = '';
      for (let item of this.cityArr) {
        if (id == item.id) {
          // console.log(item.name, '-所选城市')
          this.regionArr = item.children
          this.cityValue = item.name
          if(this.regionArr&&this.regionArr.length<=0){
            this.showRegion = false;
          }else{
            this.showRegion = true;
          }
        }
      }
      this.$emit('selMap', this.provinceValue, this.cityValue, this.RegionValue)
    },
    selectCountry(id) {
      this.RegionValue = '';
      for (let item of this.regionArr) {
        if (id == item.id) {
          // console.log(item.name, '-所选区域')
          this.RegionValue = item.name
        }
      }
      this.$emit('selMap', this.provinceValue, this.cityValue, this.RegionValue)
    },

  }
}

</script>
<style scoped type="text/css">
/deep/.my-item {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// map.vue?ebd27490